import script from "./VVVUpdateUsersNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVUpdateUsersNew.vue?vue&type=script&setup=true&lang=js"

import "./VVVUpdateUsersNew.vue?vue&type=style&index=0&id=dad0c154&lang=css"
import "./VVVUpdateUsersNew.vue?vue&type=style&index=1&id=dad0c154&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dad0c154"]])

export default __exports__